import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export default function AutoConfirmPanel() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/admin/auto-confirm-config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg) return null;
  const save = async () => {
    try { const r = await api.put("/admin/auto-confirm-config", cfg); setCfg(r.data); toast.success("Pengaturan konfirmasi otomatis disimpan"); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="auto-confirm-panel" className="rounded-2xl border border-emerald-100 bg-white p-5 shadow-sm">
      <h3 className="font-heading text-base font-bold text-slate-800">Konfirmasi Otomatis</h3>
      <label className="mt-3 flex items-center gap-2 text-sm font-semibold text-slate-700">
        <input data-testid="auto-confirm-toggle" type="checkbox" checked={!!cfg.enabled} onChange={(e) => setCfg({ ...cfg, enabled: e.target.checked })} />
        Konfirmasi otomatis pesanan tanpa bayar
      </label>
      <p className="mt-1 text-xs text-slate-500">Reservasi publik layanan tanpa pembayaran langsung Dikonfirmasi bila jadwal, data pasien, nomor WA, dan area Homecare lolos cek. Yang gagal tetap Menunggu Konfirmasi dengan alasan.</p>
      <label className="mt-3 block text-xs font-semibold text-slate-600">Nomor WA admin (notifikasi gagal &amp; ringkasan 07:00/19:00 WITA)</label>
      <input data-testid="auto-confirm-admin-wa" value={cfg.admin_wa || ""} onChange={(e) => setCfg({ ...cfg, admin_wa: e.target.value })} placeholder="cth: 6281234567890" className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm sm:w-72" />
      <button data-testid="auto-confirm-save" onClick={save} className="mt-3 block rounded-xl bg-emerald-600 px-4 py-2 text-sm font-bold text-white">Simpan</button>
    </div>
  );
}
